module.exports = __webpack_public_path__ + "static/media/projectsImage5.de1a68c7.jpg";